export const units = ['inches', 'millimeters'] as const
export type Unit = (typeof units)[number]
